import { constants } from '../constants/global.constants';
import { getFirebase } from "react-redux-firebase";
import { alertActions } from './alert.actions'
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction, Action, ActionCreator } from 'redux';
import { getProjectId } from '../selectors/project.selector';
import { RootState } from '../modules';
import { phasePlanActions, getDbFromTagType } from './phaseplan.actions';
import { ColumnType } from '../components/PhasePlan/Column';
import moment from 'moment'
import { getMileStoneByLocationId, getSelectedPhasePlanTags, getSelectedLookaheadTags, getTopLeftSelected, getSelectedPhasePlanColumn, getSelectedLookaheadColumn, getLookaheadMilestoneTags } from '../selectors/lookahead.selector';
import { LookaheadTag } from '../models/LookaheadTag';
import { getLeastPlannerTags, getLeastPlannerId, getDbFromType } from './entity.actions';
import { PhaseTag } from '../models/PhaseTag';
import { getPhaseTags, getMilestones, getPullInfo } from '../selectors/phaseplan.selector';
import { dockPadEntityMapToList } from '../containers/DockPadFormTemplates';
import { TagType, SelectedTag } from '../models/ TagType';
import { Point } from '../modules/ui.reducer';
import { getLocationPathName } from '../selectors/util.selector';
import { getCopiedLookaheadTags, getCopiedPhaseTags } from '../selectors/dialog.selector';

const _ = require('lodash')

export const PHASE_PLAN_DIALOG_OPEN = 'PHASE_PLAN_DIALOG_OPEN'
export const PHASE_PLAN_DIALOG_CLOSED = 'PHASE_PLAN_DIALOG_CLOSED'

export const PHASE_PLAN_START_DIALOG_OPEN = 'PHASE_PLAN_START_DIALOG_OPEN'
export const PHASE_PLAN_START_DIALOG_CLOSE = 'PHASE_PLAN_START_DIALOG_CLOSE'
export const HELP_INFO_DIALOG_OPEN = 'HELP_INFO_DIALOG_OPEN'
export const HELP_INFO_DIALOG_CLOSE = 'HELP_INFO_DIALOG_CLOSE'
export const CONSTRAINT_DIALOG_OPEN = 'CONSTRAINT_DIALOG_OPEN'
export const CONSTRAINT_DIALOG_CLOSE = 'CONSTRAINT_DIALOG_CLOSE'
export const CONSTRAINT_LOG_DIALOG_OPEN = 'CONSTRAINT_LOG_DIALOG_OPEN'
export const CONSTRAINT_LOG_DIALOG_CLOSE = 'CONSTRAINT_LOG_DIALOG_CLOSE'
export const COMMIT_DIALOG_OPEN = 'COMMIT_DIALOG_OPEN'
export const COMMIT_DIALOG_CLOSE = 'COMMIT_DIALOG_CLOSE'
export const VARIANCE_LOG_DIALOG_OPEN = 'VARIANCE_LOG_DIALOG_OPEN'
export const VARIANCE_LOG_DIALOG_CLOSE = 'VARIANCE_LOG_DIALOG_CLOSE'
export const END_COMMITMENT_DIALOG_OPEN = 'END_COMMITMENT_DIALOG_OPEN'
export const END_COMMITMENT_DIALOG_CLOSE = 'END_COMMITMENT_DIALOG_CLOSE'
export const SET_PULL_DATE_DIALOG_OPEN = 'SET_PULL_DATE_DIALOG_OPEN'
export const SET_PULL_DATE_DIALOG_CLOSE = 'SET_PULL_DATE_DIALOG_CLOSE'
export const ROW_COUNT_DIALOG_OPEN = 'ROW_COUNT_DIALOG_OPEN'
export const ROW_COUNT_DIALOG_CLOSED = 'ROW_COUNT_DIALOG_CLOSED'
export const CLEAR_COPY_TAGS = 'CLEAR_COPY_TAGS'
export const COPY_TAGS = 'COPY_TAGS'
export const MRP_DIALOG_OPEN = 'MRP_DIALOG_OPEN'
export const MRP_DIALOG_CLOSED = 'MRP_DIALOG_CLOSED'
export const PRINT_BOARD_DIALOG_OPEN = 'PRINT_BOARD_DIALOG_OPEN'
export const PRINT_BOARD_DIALOG_CLOSE = 'PRINT_BOARD_DIALOG_CLOSE'

export const HUDDLE_SETTING_DIALOG_OPEN = 'HUDDLE_SETTING_DIALOG_OPEN'
export const HUDDLE_SETTING_DIALOG_CLOSE = 'HUDDLE_SETTING_DIALOG_CLOSE'

export interface HuddleSettingsDialogOpenAction extends Action {
    type: 'HUDDLE_SETTING_DIALOG_OPEN'
    payload: {
    }
}


export interface  HuddleSettingsDialogCloseAction extends Action {
    type: 'HUDDLE_SETTING_DIALOG_CLOSE'
    payload: {
        
    }
}

export interface RowCountDialogOpenAction extends Action {
    type: 'ROW_COUNT_DIALOG_OPEN'
    payload: {
        row: Number
    }
}


export interface RowCountDialogCloseAction extends Action {
    type: 'ROW_COUNT_DIALOG_CLOSED'
    payload: {
        
    }
}

export interface PhasePlanOpenAction extends Action {
    type: 'PHASE_PLAN_DIALOG_OPEN'
    payload: {
        
    }
}

export interface MRPOpenAction extends Action {
    type: 'MRP_DIALOG_OPEN',
    payload: {

    }
}


export interface PhasePlanCloseAction extends Action {
    type: 'PHASE_PLAN_DIALOG_CLOSED'
    payload: {
        
    }
}

export interface MRPCloseAction extends Action {
    type: 'MRP_DIALOG_CLOSED',
    payload: {
        
    }
}

export interface PhasePlanStartDialogOpenAction extends Action {
    type: 'PHASE_PLAN_START_DIALOG_OPEN'
    payload: {
        
    }
}

export interface PhasePlanStartDialogCloseAction extends Action {
    type: 'PHASE_PLAN_START_DIALOG_CLOSE'
    payload: {
        
    }
}

export interface HelpInfoDialogOpenAction extends Action {
    type: 'HELP_INFO_DIALOG_OPEN'
    payload: {
        
    }
}

export interface HelpInfoDialogCloseAction extends Action {
    type: 'HELP_INFO_DIALOG_CLOSE'
    payload: {
        
    }
}

export interface SetPullDateOpenAction extends Action {
    type: 'SET_PULL_DATE_DIALOG_OPEN'
    payload: {
    }
}

export interface SetPullDateCloseAction extends Action {
    type: 'SET_PULL_DATE_DIALOG_CLOSE'
    payload: {
    }
}

export interface ConstraintDialogOpenAction extends Action {
    type: 'CONSTRAINT_DIALOG_OPEN'
    payload: {
        constraintId?: string
    }
}

export interface ConstraintDialogCloseAction extends Action {
    type: 'CONSTRAINT_DIALOG_CLOSE'
    payload: {
        
    }
}

export interface CommitDialogOpenAction extends Action {
    type: 'COMMIT_DIALOG_OPEN',
    payload: {

    }
}

export interface CommitDialogCloseAction extends Action {
    type: 'COMMIT_DIALOG_CLOSE',
    payload: {
        
    }
}

export interface PrintBoardDialogOpenAction extends Action {
    type: 'PRINT_BOARD_DIALOG_OPEN',
    payload: {

    }
}

export interface PrintBoardDialogCloseAction extends Action {
    type: 'PRINT_BOARD_DIALOG_CLOSE',
    payload: {
        
    }
}



export interface VarianceLogDialogOpenAction extends Action {
    type: 'VARIANCE_LOG_DIALOG_OPEN',
    payload: {
        
    }
}

export interface VarianceLogDialogCloseAction extends Action {
    type: 'VARIANCE_LOG_DIALOG_CLOSE',
    payload: {
        
    }
}

export interface ConstraintLogDialogOpenAction extends Action {
    type: 'CONSTRAINT_LOG_DIALOG_OPEN'
    payload: {

    }
}

export interface ConstraintLogDialogCloseAction extends Action {
    type: 'CONSTRAINT_LOG_DIALOG_CLOSE'
    payload: {
        
    }
}

export interface EndCommitmentDialogOpenAction extends Action {
    type: 'END_COMMITMENT_DIALOG_OPEN'
    payload: {
        
    }
}

export interface EndCommitmentDialogCloseAction extends Action {
    type: 'END_COMMITMENT_DIALOG_CLOSE'
    payload: {
        
    }
}

export interface CopyTagsAction extends Action {
    type: 'COPY_TAGS'
    payload: {
        tags: Record<string, SelectedTag>,
        type: ColumnType,
        isMilestone: Boolean | null,
    }
}

export interface ClearCopyTagsActions extends Action {
    
    type: 'CLEAR_COPY_TAGS'
    payload: {}
}


const openHuddleSettingDialog: ActionCreator<HuddleSettingsDialogOpenAction> = () => ({
    type: HUDDLE_SETTING_DIALOG_OPEN,
    payload: {

    }
})

const closedHuddleSettingDialog: ActionCreator<HuddleSettingsDialogCloseAction> = () => ({
    type: HUDDLE_SETTING_DIALOG_CLOSE,
    payload: {

    }
})

const openPrintBoardDialog: ActionCreator<PrintBoardDialogOpenAction> = () => ({
    type: PRINT_BOARD_DIALOG_OPEN,
    payload: {

    }
})

const closePrintBoardDialog: ActionCreator<PrintBoardDialogCloseAction> = () => ({
    type: PRINT_BOARD_DIALOG_CLOSE,
    payload: {
        
    }
})

const openRowCountDialog: ActionCreator<RowCountDialogOpenAction> = (row: number) => ({
    type: ROW_COUNT_DIALOG_OPEN,
    payload: {
        row
    }
})

const closedRowCountDialog: ActionCreator<RowCountDialogCloseAction> = (row: number) => ({
    type: ROW_COUNT_DIALOG_CLOSED,
    payload: {
        row
    }
})

const openHelpInfoDialog:ActionCreator<HelpInfoDialogOpenAction> = () => ({
    type: HELP_INFO_DIALOG_OPEN,
    payload: {

    }
})

const closeHelpInfoDialog:ActionCreator<HelpInfoDialogCloseAction> = () => ({
    type: HELP_INFO_DIALOG_CLOSE,
    payload: {

    }
})

const openSetPullDialog:ActionCreator<SetPullDateOpenAction> = () => ({
    type: SET_PULL_DATE_DIALOG_OPEN,
    payload: {

    }
})

const closeSetPullDialog:ActionCreator<SetPullDateCloseAction> = () => ({
    type: SET_PULL_DATE_DIALOG_CLOSE,
    payload: {
        
    }
})

const openConstraintDialog:ActionCreator<ConstraintDialogOpenAction> = (constraintId: string | undefined) => ({
    type: CONSTRAINT_DIALOG_OPEN,
    payload: {
        constraintId
    }
})

const closeConstraintDialog:ActionCreator<ConstraintDialogCloseAction> = () => ({
    type: CONSTRAINT_DIALOG_CLOSE,
    payload: {

    }
})

const openConstraintLogDialog:ActionCreator<ConstraintLogDialogOpenAction> = () => ({
    type: CONSTRAINT_LOG_DIALOG_OPEN,
    payload: {
    }
})

const closeConstraintLogDialog:ActionCreator<ConstraintLogDialogCloseAction> = () => ({
    type: CONSTRAINT_LOG_DIALOG_CLOSE,
    payload: {

    }
})

const openCommitDialog:ActionCreator<CommitDialogOpenAction> = () => ({
    type: COMMIT_DIALOG_OPEN,
    payload: {

    }
})

const openVarianceLogDialog:ActionCreator<VarianceLogDialogOpenAction> = () => ({
    type: VARIANCE_LOG_DIALOG_OPEN,
    payload: {

    }
})

const closeCommitDialog:ActionCreator<CommitDialogCloseAction> = () => ({
    type: COMMIT_DIALOG_CLOSE,
    payload: {

    }  
})

const closeVarianceLogDialog:ActionCreator<VarianceLogDialogCloseAction> = () => ({
    type: VARIANCE_LOG_DIALOG_CLOSE,
    payload: {

    }
})

const openPhasePlanDialog: ActionCreator<PhasePlanOpenAction> = () => ({
    type: PHASE_PLAN_DIALOG_OPEN,
    payload: {

    }
})

const openMRPDialog: ActionCreator<MRPOpenAction> = () => ({
    type: MRP_DIALOG_OPEN,
    payload: {

    }
})

const closedMRPDialog: ActionCreator<MRPCloseAction> = () => ({
    type: MRP_DIALOG_CLOSED,
    payload: {

    }
})

const openEndCommitmentDialog:ActionCreator<EndCommitmentDialogOpenAction> = () => ({
    type: END_COMMITMENT_DIALOG_OPEN,
    payload: {

    }
})

const closeEndCommitmentDialog:ActionCreator<EndCommitmentDialogCloseAction> = () => ({
    type: END_COMMITMENT_DIALOG_CLOSE,
    payload: {

    }
})

const openPhasePlanDialogAsync = () => {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        dispatch(openPhasePlanDialog())
    }
}

const closePhasePlanDialog: ActionCreator<PhasePlanCloseAction> = () => ({
    type: PHASE_PLAN_DIALOG_CLOSED,
    payload: {

    }
})

const openPhasePlanStart: ActionCreator<PhasePlanStartDialogOpenAction> = (phasePlanKey) => ({
    type: PHASE_PLAN_START_DIALOG_OPEN,
    payload: {
        startLookaheadPhaseKey: phasePlanKey
    }
})

const closePhasePlanStartDialog: ActionCreator<PhasePlanStartDialogCloseAction> = () => ({
    type: PHASE_PLAN_START_DIALOG_CLOSE,
    payload: {

    }
})



        
const copyTagsAction: ActionCreator<CopyTagsAction> = (tags: Record<string, SelectedTag>, type: ColumnType, isMilestone?: boolean) => ({
    type: COPY_TAGS,
    payload: {
        tags,
        type,
        isMilestone,
    },
    meta: {
        debounce: {
            time: 500
        }
    }
})

const clearCopyTagsAction: ActionCreator<ClearCopyTagsActions> = () => ({
    type: CLEAR_COPY_TAGS, 
    payload: {}
}) 

const openPhasePlanStartDialog = (phasePlanKey: string) => {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        const state = getState()
        
        const phaseTags = getPhaseTags(state)
        const locations = getMilestones(state)
        const pullInfo = getPullInfo(state)

        const tagList = dockPadEntityMapToList(phaseTags)
        const locationByName = _.groupBy(locations, 'location')
        const tagsByLocation = _.groupBy(tagList, 'locationId')

        let found = false

        if(!pullInfo) {
            dispatch(alertActions.error("Please Add Pull Date"))
        } else {
            dispatch(openPhasePlanStart(phasePlanKey))
        }
        return
    }
}

const copyTags = (tags: Record<string, SelectedTag>, type: ColumnType, isMilestone?: boolean)  => {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        dispatch(copyTagsAction(tags, type, isMilestone))
        dispatch(alertActions.success('Copied'))
    }
}

const showBatchTagDialog = (tags: Record<string, SelectedTag>) => {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        dispatch({
            type: constants.OPEN_BATCH_TAG_DIALOG,
            batchTagIds: tags,
            
        })
    }
}

const batchDialogClose = () => {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        dispatch({
            type: constants.CLOSE_BATCH_TAG_DIALOG,
               
        })
    }
}

const pasteTags = (isBacklog:boolean, type: ColumnType) => {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        try{
            const firebase = getFirebase();
            const state = getState()

            const pathName:string = getLocationPathName(state)
            let selectedTagz: Record<string, SelectedTag>
            let selectedPoint:Point
            if(pathName === '/phasePlan') {
                selectedTagz = getCopiedPhaseTags(state)
                selectedPoint = getSelectedPhasePlanColumn(state)

            }

            if(pathName === '/lookahead') {
                selectedTagz = getCopiedLookaheadTags(state)
                selectedPoint = getSelectedLookaheadColumn(state)
            }
            
            if(!selectedTagz || Object.keys(selectedTagz).length <= 0) return

            const projectId = getProjectId(state)
            const lookaheadOrPhasePlanId = getLeastPlannerId(state, type)

            const ref = firebase.database().ref();

            const dbType = getDbFromType(type)
            let tags = getLeastPlannerTags(state, type)
            if(!tags) {
                return
            }

            if(!isBacklog) {
            // const tag = tags[tagId]
                //Get firstTag
                const firstTag = getTopLeftSelected(selectedTagz)
                
                if(!firstTag) return
                
                // Get the tag column and index
                const oldPosition = firstTag.position

                const oldColumnId = oldPosition.column
                const oldIndexId = oldPosition.row

                const newColumnId = selectedPoint.column
                const newIndexId = selectedPoint.row

                //Calculate the column offset and index offset new - old = offset
                let offsetColumn: number
                let offsetIndex: number
            
                const newColumnMoment = moment(newColumnId)
                const oldColumnMoment = moment(oldColumnId)
            
                if(newColumnMoment.isValid() && oldColumnMoment.isValid()) {
                    offsetColumn = newColumnMoment.diff(oldColumnMoment, 'days')
                } else {
                    offsetColumn = newColumnId - oldColumnId
                }
            
                offsetIndex = newIndexId - oldIndexId

                // adjust their column and index by adding offset old + offset = new
                const adjustedSelectedTagList:any[] = Object.keys(selectedTagz).filter(tagId => !!tags[tagId] && !!selectedTagz[tagId]).map(tagId => {
                    const selectedTag = selectedTagz[tagId]
                    let newColumn = -1

                    if(pathName === '/phasePlan') {
                        newColumn = parseInt(selectedTag.position.column,10) +  ( newColumnMoment._i - oldColumnMoment._i )
                    }

                    if(pathName === '/lookahead') {

                        newColumn = moment(selectedTag.position.column).add(offsetColumn, 'days').valueOf()

                    }
                    const newRow = parseInt(selectedTag.position.row, 10) + parseInt(offsetIndex, 10)

                    return {
                        tagId: tagId,
                        column: newColumn,
                        row: newRow,
                        tagType: selectedTag.tagCardType
                    }
                })

                //make update map
                const updates = adjustedSelectedTagList.reduce((obj, selectTag) => {
                    const tag = tags[selectTag.tagId]
                    let tagType
                    if(pathName === '/phasePlan') {
                        tagType = ColumnType.PhasePlan
                    }

                    if(pathName === '/lookahead') {

                        tagType = ColumnType.Lookahead

                    }
                    const tagTypeDb = getDbFromTagType(selectTag.tagType, !!tag.isMilestone)

                    delete tag['uid']
                    delete tag['dayOffset']
                    delete tag['tagCardType']
                    delete tag['isMilestone']
                    delete tag['createdAt']
                    delete tag['tagType']

                    const newId = ref.push().key

                    if(type === ColumnType.Lookahead) {
                        const lookaheadTag = tag as LookaheadTag
                        lookaheadTag.tagDate = moment(parseInt(selectTag.column, 10)).format('l')
                        lookaheadTag.indexId = parseInt(selectTag.row, 10)
                        obj[`/projects/${projectId}/${dbType}/${lookaheadOrPhasePlanId}/${tagTypeDb}/${newId}`] = lookaheadTag
                    }

                    if(type === ColumnType.PhasePlan) {
                        const phasePlanTag = tag as PhaseTag
                        phasePlanTag.column =  parseInt(selectTag.column, 10)
                        phasePlanTag.indexId = parseInt(selectTag.row, 10)
                        obj[`/projects/${projectId}/${dbType}/${lookaheadOrPhasePlanId}/${tagTypeDb}/${newId}`] = phasePlanTag
                    }
                    return obj

                }, {} as Record<string, PhaseTag | LookaheadTag>)

                try {

                    firebase.database().ref().update(updates).then(() => {
                    })
                    .catch((error) => {
                        console.log('saving paste issue 2', error )
                    })

                }catch(e) {
                }
            } else {
                const updates = Object.keys(tagsAndType).filter((tagId: string) => !!tags[tagId]).reduce((obj, tagId) => {
                    const tag = tags[tagId]

                    let tagType
                    if(pathName === '/phasePlan') {
                        tagType = ColumnType.PhasePlan
                    }

                    if(pathName === '/lookahead') {

                        tagType = ColumnType.Lookahead

                    }
                    const tagTypeDb = getDbFromTagType(tagType, !!tag.isMilestone)

                    delete tag['uid']
                    delete tag['dayOffset']
                    delete tag['tagCardType']
                    delete tag['isMilestone']
                    delete tag['tagType']

                    
                    const newId = ref.push().key
                    if(type === ColumnType.Lookahead) {
                        const lookaheadTag = tag as LookaheadTag
                        lookaheadTag.tagDate = null
                        obj[`/projects/${projectId}/${dbType}/${lookaheadOrPhasePlanId}/${tagTypeDb}/${newId}`] = lookaheadTag
                    }

                    if(type === ColumnType.PhasePlan) {
                        const phasePlanTag = tag as PhaseTag
                        phasePlanTag.column =  null
                        obj[`/projects/${projectId}/${dbType}/${lookaheadOrPhasePlanId}/${tagTypeDb}/${newId}`] = phasePlanTag
                    }
                    return obj
                }, {} as Record<string, null>)

                firebase.database().ref().update(updates)
            }
            

            dispatch(alertActions.success('Pasted'));
        }catch(e) {
            dispatch(alertActions.error('Pasted Error'));

            console.log('paste errors e')
        }

    }
}

export type DialogAction = PhasePlanOpenAction | PhasePlanCloseAction | CopyTagsAction


export const dialogActions = {
    pasteTags,
    openPhasePlanDialogAsync,
    openPhasePlanDialog,
    closePhasePlanDialog,
    openResourceDialog,
    closeResourceDialog,
    openDeleteResourceDialog,
    closeDeleteResourceDialog,
    openEditResourceDialog,
    openAddIssueDialog,
    openEditIssueDialog,
    openDeleteIssueDialog,
    closeDeleteIssueDialog,
    deleteIssue,
    closeAddIssueDialog,
    openTimelineDialog,
    closeTimelineDialog,
    openProjectUserDialog,
    closeProjectUserDialog,
    showTagDialog,
    closeTagDialog,
    showTradeDialog,
    closeTradeDialog,
    showMilestoneDialog,
    closeMilestoneDialog,
    showDeleteTagDialog,
    closeDeleteTagDialog,
    showDuplicateTagDialog,
    closeDuplicateTagDialog,
    showRipTagDialog,
    closeRipTagDialog,
    showLookaheadDialog,
    closeLookaheadDialog,
    copyTags,
    openHelpInfoDialog,
    closeHelpInfoDialog,
    openConstraintDialog,
    closeConstraintDialog,
    openConstraintLogDialog,
    closeConstraintLogDialog,
    openCommitDialog,
    closeCommitDialog,
    openVarianceLogDialog,
    closeVarianceLogDialog,
    openEndCommitmentDialog,
    closeEndCommitmentDialog,
    openSetPullDialog,
    closeSetPullDialog,
    clearCopyTagsAction,
    showBatchTagDialog,
    batchDialogClose,
    openRowCountDialog,
    closedRowCountDialog,
    openMRPDialog,
    closedMRPDialog,
    openPrintBoardDialog,
    closePrintBoardDialog,
    openHuddleSettingDialog,
    closedHuddleSettingDialog
}



function showMilestoneDialog(location) {
    return (dispatch, getState) => {
        dispatch({
            type: constants.OPEN_MILESTONE_DIALOG,
            payload: {
                location
            },
               
        });
    };
}

function closeMilestoneDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.CLOSE_MILESTONE_DIALOG,
               
        });
    };
}

function showTagDialog (tagId:string | null) {
    return (dispatch, getState) => {
        dispatch({
            type: constants.OPEN_TAG_DIALOG,
            payload: {
                tagId
            },
               
        });
    };
}

function closeTagDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.CLOSE_TAG_DIALOG,
               
        });
    };
}

function closeTradeDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.CLOSE_TRADE_DIALOG,
               
        });
    };
}

function showTradeDialog (tradeId) {
    return (dispatch, getState) => {
        dispatch({
            type: constants.OPEN_TRADE_DIALOG,
            payload: {
                tradeId
            },
               
        });
    };
}

function openResourceDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.OPEN_RESOURCE_DIALOG,
               
        });
    };
}

function closeResourceDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.CLOSE_RESOURCE_DIALOG,
               
        });
    };
}

function openProjectUserDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.OPEN_PROJECT_USER_DIALOG,
               
        });
    }
}

function closeProjectUserDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.CLOSE_PROJECT_USER_DIALOG,
               
        });
    }
}

function openDeleteResourceDialog(resourceUid, projectId) {
    return (dispatch, getState) => {
        dispatch({
            type: constants.OPEN_DELETE_RESOURCE_DIALOG,
            resourceUid: resourceUid,
            projectId: projectId,
               
        });
    };
}

function closeDeleteResourceDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.CLOSE_DELETE_RESOURCE_DIALOG,
               
        });
    };
}

function openAddIssueDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.ISSUEDIALOG_OPEN,
               
        });
    };
}

function openEditIssueDialog(issueId) {
    return (dispatch, getState) => {
        dispatch({
            type: constants.OPEN_EDIT_ISSUE_DIALOG,
            issueId: issueId
        });
    };
}

function closeAddIssueDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.ISSUEDIALOG_CLOSE,
               
        });
    };
}

function openDeleteIssueDialog(projectId, issueId) {
    return (dispatch, getState) => {
        dispatch({
            type: constants.OPEN_DELETE_ISSUE_DIALOG,
            issueId: issueId,
            projectId: projectId,
               
        });
    };
}

function closeDeleteIssueDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.CLOSE_DELETE_ISSUE_DIALOG,
               
        });
    };
}

function deleteIssue (projectId, issueId) {
    const firebase = getFirebase();
    return (dispatch, getState ) => {
        firebase.database().ref(`projects/${projectId}/issues/${issueId}`).remove()
      .then(() => {
          dispatch(alertActions.success('Issue Deleted'))
      })
      .catch((error) => {
          dispatch(alertActions.error('Error in Deleting Issue'))
      })
    }
}

function openEditResourceDialog(resourceUid) {
    return (dispatch, getState) => {
        dispatch({
            type: constants.OPEN_EDIT_RESOURCE_DIALOG,
            resourceUid: resourceUid
        });
    };
}

function openTimelineDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.OPEN_TIMELINE_DIALOG,

        })
    }
}

function closeTimelineDialog() {
    return (dispatch, getState) => {
        dispatch({
            type: constants.CLOSE_TIMELINE_DIALOG,

        })
    }
}

function showDeleteTagDialog(tags:Record<string, SelectedTag>, type: ColumnType) {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        dispatch({
            type: constants.OPEN_DELETE_TAG_DIALOG,
            deleteTagIds: tags,
            deleteTagType: type,
               
        })
    }
}

function closeDeleteTagDialog() {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        dispatch({
            type: constants.CLOSE_DELETE_TAG_DIALOG,
               
        })
    }
}

function showDuplicateTagDialog(tagIds:Record<string, SelectedTag>, type: ColumnType) {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        dispatch({
            type: constants.OPEN_DUPLICATE_TAG_DIALOG,
            dupTagIds: tagIds,
            dupTagType: type,
               
        })
    }
}

function closeDuplicateTagDialog() {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        dispatch({
            type: constants.CLOSE_DUPLICATE_TAG_DIALOG,
               
        })
    }
}

function showRipTagDialog(tagId:string, tagType: TagType) {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        dispatch({
            type: constants.OPEN_RIP_TAG_DIALOG,
            ripTagId: tagId,
            ripTagType: tagType,
               
        })
    }
}

function closeRipTagDialog() {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        dispatch({
            type: constants.CLOSE_RIP_TAG_DIALOG,
               
        })
    }
}

function showLookaheadDialog(phasePlanKey:string) {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        dispatch(openPhasePlanStartDialog(phasePlanKey))
    }
}

function closeLookaheadDialog() {
    return (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => any) => {
        dispatch(closePhasePlanStartDialog())
        dispatch(phasePlanActions.lookaheadOffDayClear())
    }
}


// WEBPACK FOOTER //
// ./src/actions/dialog.actions.ts